<script setup lang="ts">
import {
	FormField,
	FormLabel,
	FormDescription,
	Toggle,
	FormControl,
	Button,
} from '@laam/ui/base';

import TextInput from '../TextInput.vue';
import ButtonLoader from '../ButtonLoader.vue';

interface Props {
	actionTitle: string;
	actionLoading: boolean;
}
defineProps<Props>();
</script>
<template>
	<TextInput
		field-name="name"
		label="List name"
		place-holder="Name your list"
		class="mb-sm"
		description="50 characters maximum"
	/>
	<FormField v-slot="{ value, handleChange }" name="public">
		<FormItem class="flex justify-start">
			<div class="space-y-0.5 grow">
				<FormLabel class="text-base">Set as private</FormLabel>
				<FormDescription>
					Only you can view items in that list.
				</FormDescription>
			</div>
			<FormControl>
				<Toggle :checked="value" @update:checked="handleChange" />
			</FormControl>
		</FormItem>
	</FormField>
	<Button
		size="lg"
		type="submit"
		class="w-full !mt-8xl"
		:disabled="actionLoading"
	>
		<ButtonLoader v-if="actionLoading" />
		<template v-else>{{ actionTitle }}</template>
	</Button>
</template>
